export const navigationMiddleware = () => (next: any) => (action: any) => {
  if (action.type === 'nav/redirect') {
    window.dispatchEvent(
      new CustomEvent('app-redirect', { detail: action.payload })
    );
  }
  return next(action);
};